import { rutValidator } from './rut-helpers/rutValidator';
import { MAX_COMPANY_VALUE, MIN_COMPANY_VALUE } from './rut-helpers/constants';

export const errorCode = 'INVALID_RUT';
export const validateCompanyRut = rutValidator({
  errorCode,
  min: MIN_COMPANY_VALUE,
  max: MAX_COMPANY_VALUE
});
